import React, { useEffect } from 'react';
import Modal from 'Douleutaras/components/Modal/Modal';
import PopupServiceImg from 'Assets/layout/dashboard/popup-service.png';
import DefaultModal from 'Douleutaras/components/modals/DefaultModal';
import { Trans } from 'react-i18next';
import ModalSelectionItem from 'Douleutaras/components/modals/parts/ModalSelectionItem';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import {
  BidMilestoneConfiguration,
  BID_MILESTONES,
  NEED_HELP_MILESTONES
} from 'Douleutaras/constants/ccf/need-help-options';
import { useCurrentMilestoneSettings } from 'Douleutaras/hooks/jobs/milestones';
import { FormattedMilestone } from 'Douleutaras/types/index';
import { useAppDispatch, useAppSelector } from 'Douleutaras/redux/hooks';
import {
  bidBuyerStatusEndpoint,
  getBidBuyerStatus
} from 'Douleutaras/redux/data/jobBids/jobBidsStatusBuyerSlice';
import { jobBidsSelectors } from 'Douleutaras/redux/data/jobBids/jobBidsSlice';

interface SelectMilestoneProps {
  bidId: string;
  currentMilestone: FormattedMilestone;
  isOpen: boolean;
  jobId?: string;
  jobCategoryId?: string;
  title: string | React.ReactElement;
  showBackButton?: boolean;
  userMugshot?: string;
  onBack?(): void;
  onSelectMilestoneCallback?(milestoneKey: NEED_HELP_MILESTONES): void;
  setIsOpen(modalStatus): void;
}

const SelectMilestone = ({
                           bidId,
                           isOpen,
                           jobId,
                           setIsOpen,
                           title,
                           showBackButton = true,
                           userMugshot,
                           onBack,
                           onSelectMilestoneCallback
                         }: SelectMilestoneProps) => {
  const bid = useAppSelector(state => jobBidsSelectors.selectById(state, bidId));

  if (!bid) { // No bid, don't render the modal
    // tslint:disable-next-line:no-null-keyword
    return null;
  }
  const currentMilestoneSettings: BidMilestoneConfiguration = useCurrentMilestoneSettings(jobId, bidId);
  const dispatch = useAppDispatch();
  const metaKey = bidBuyerStatusEndpoint(jobId, bidId);
  const bidBuyerStatus = useAppSelector(state => state.jobBidsStatusBuyer);

  useEffect(() => {
    // Check if buyer status is fetched, if not, fetch it.
    if (typeof bidBuyerStatus?.meta?.[metaKey] === 'undefined' && isOpen) {
      dispatch(getBidBuyerStatus({
          jobId,
          bidId
        })
      );
    }
  }, [ isOpen ]);

  return (
    <Modal isOpen={isOpen} dismissCallback={() => setIsOpen(false)}>
      <DefaultModal
        serviceIcon={PopupServiceImg}
        serviceIconAlt={<Trans>T.CCF.SELECT MILESTONE MODAL.IMAGE ALT TEXT</Trans>}
        title={title}
        backText={<Trans>T.CCF.SELECT MILESTONE MODAL.BACK BUTTON TEXT</Trans>}
        backTextAriaLabel={<Trans>T.CCF.SELECT MILESTONE MODAL.BACK BUTTON TEXT</Trans>}
        closeAriaLabel={<Trans>T.CCF.SELECT MILESTONE MODAL.CLOSE ICON LABEL</Trans>}
        closeButtonCallback={() => setIsOpen(false)}
        backButtonCallback={typeof onBack === 'function' ? onBack : () => false}
        showBackButton={showBackButton}
        userMugshot={userMugshot}
      >
        { Object.keys(BID_MILESTONES)
          .map((milestoneKey: NEED_HELP_MILESTONES) => {
            const milestone = BID_MILESTONES[milestoneKey];
            const milestoneIsEnabled = currentMilestoneSettings?.enabledMilestones.includes(milestoneKey);

            return (
              <ModalSelectionItem key={`key_${milestoneKey}`}>
                <QuickButton
                  title={milestone.title}
                  subtitle={milestone.description}
                  onClick={() => onSelectMilestoneCallback(milestoneKey)}
                  disabled={!milestoneIsEnabled}
                />
              </ModalSelectionItem>
            );
        })}
      </DefaultModal>
    </Modal>
  );
};

export default SelectMilestone;
